import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { formatDate, setTimeStrToInterval, formatTime, addHours } from './../helpers/timeFormatting'

const today = new Date()
const tomorrow = new Date()
tomorrow.setDate(tomorrow.getDate() + 1)
const endTime = setTimeStrToInterval(formatTime(addHours(today, 4)))
const startTime = setTimeStrToInterval(formatTime(addHours(today, 2)))

const initialState = {
	contractId: '',
	contractLabel: '',
	crumbs: ['Destinations', 'When', 'Details', 'Compare'],
	data: [],
	destinationId: '',
	destination: '',
	destinationLatLong: '',
	endDate: formatDate(today),
	endTime,
	endId: '',
	end: '',
	endLatLong: '',
	// eslint-disable-next-line @typescript-eslint/camelcase
	is_return: null,
	index: 0,
	locationData: [],
	journey: {
		origin: '',
		destination: '',
		polylineOptions: {
			strokeColor: 'rgba(0,0,0,0.2)',
		},
	},
	passengers: 0,
	showResults: false,
	showLastRoute: false,
	start: '',
	startId: '',
	startDate: formatDate(today),
	startTime,
	startLatLong: '',
	steps: [1, 2, 3, 4, 5],
	totalMiles: 0,
	transition: 'flyInFromLeft',
}

const increment = (index, state) => {
	return index + 1 === state.steps.length ? index : index + 1
}
const decrement = index => {
	return index - 1
}

export const journeyPlannerSlice = createSlice({
	name: 'journeyPlanner',
	initialState,
	reducers: {
		setTotalMiles(state, action: PayloadAction<number>) {
			state.totalMiles += action.payload
		},
		setAppFromSession(state, action) {
			state = { ...action.payload }
		},
		setContractLabel(state, action: PayloadAction<string>) {
			state.contractLabel = action.payload
		},
		nextStep(state) {
			const incrementedStep = increment(state.index, state)
			state.index = incrementedStep
			state.transition = 'flyInFromLeft'
		},
		previousStep(state) {
			const decrementStep = decrement(state.index)
			state.index = decrementStep
			state.transition = 'flyInFromRight'
		},
		backToStart(state) {
			state.index = 0
		},
		isReturn(state, action: PayloadAction<boolean>) {
			// eslint-disable-next-line @typescript-eslint/camelcase
			state.is_return = action.payload
		},
		showLastRoute(state, action: PayloadAction<boolean>) {
			state.showLastRoute = action.payload
		},
		goTo(state, action: PayloadAction<number>) {
			state.index = action.payload
		},
		startAddress(state, action: PayloadAction<string>) {
			state.start = action.payload
		},
		endAddress(state, action: PayloadAction<string>) {
			state.end = action.payload
		},
		startId(state, action: PayloadAction<string>) {
			state.startId = action.payload
		},
		endId(state, action: PayloadAction<string>) {
			state.endId = action.payload
		},
		destinationId(state, action: PayloadAction<string>) {
			state.destinationId = action.payload
		},
		destinationAddress(state, action: PayloadAction<string>) {
			state.destination = action.payload
		},
		locationData(state, action: PayloadAction<object[]>) {
			state.locationData = action.payload
		},
		passengers(state, action: PayloadAction<number>) {
			state.passengers = action.payload
		},
		contractId(state, action: PayloadAction<string>) {
			state.contractId = action.payload
		},
		startDate(state, action: PayloadAction<string>) {
			state.startDate = action.payload
		},
		setStartTime(state, action: PayloadAction<string>) {
			state.startTime = action.payload
		},
		endDate(state, action: PayloadAction<string>) {
			state.endDate = action.payload
		},
		setEndTime(state, action: PayloadAction<string>) {
			state.endTime = action.payload
		},
		startLatLong(state, action: PayloadAction<string>) {
			state.startLatLong = action.payload
		},
		endLatLong(state, action: PayloadAction<string>) {
			state.endLatLong = action.payload
		},
		destinationLatLong(state, action: PayloadAction<string>) {
			state.destinationLatLong = action.payload
		},
		journey(
			state,
			action: PayloadAction<{
				origin: string
				destination: string
				polylineOptions: {
					strokeColor: string
				}
			}>
		) {
			state.journey = { ...action.payload }
		},
	},
})

export const {
	journey,
	destinationLatLong,
	endLatLong,
	startLatLong,
	setEndTime,
	endDate,
	setStartTime,
	startDate,
	contractId,
	passengers,
	locationData,
	destinationAddress,
	destinationId,
	endId,
	startId,
	endAddress,
	startAddress,
	goTo,
	setTotalMiles,
	setAppFromSession,
	setContractLabel,
	nextStep,
	previousStep,
	backToStart,
	isReturn,
	showLastRoute,
} = journeyPlannerSlice.actions
